module.exports = __webpack_public_path__ + "static/media/roc_bla_sit_spe_met.d9703e61.png";